import { render, staticRenderFns } from "./LoadingSpinner_35.vue?vue&type=template&id=5a631ea0&"
import script from "./LoadingSpinner_35.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner_35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports